(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["elixvp-featured-fragrance"] && !Shopify.designMode) return;
  try {
    
class ElixvpFeaturedFragrance extends HTMLElement{
  connectedCallback(){
    this.slides=[...this.querySelectorAll('[data-eff-slide]')];this.i=0;this.timer=null;
    this.querySelector('[data-eff-prev]')?.addEventListener('click',()=>this.go(this.i-1));
    this.querySelector('[data-eff-next]')?.addEventListener('click',()=>this.go(this.i+1));
    this.addEventListener('mouseenter',()=>this.stop());this.addEventListener('mouseleave',()=>this.start());
    this.start();
  }
  go(n){if(this.slides.length<2)return;this.slides[this.i]?.classList.remove('is-active');this.i=(n+this.slides.length)%this.slides.length;this.slides[this.i]?.classList.add('is-active');this.stop();this.start()}
  start(){if(this.dataset.autoplay!=='true'||this.slides.length<2||matchMedia('(prefers-reduced-motion: reduce)').matches)return;this.timer=setInterval(()=>this.go(this.i+1),Number(this.dataset.delay)||6000)}
  stop(){if(this.timer){clearInterval(this.timer);this.timer=null}}
  disconnectedCallback(){this.stop()}
}
if(!customElements.get('elixvp-featured-fragrance'))customElements.define('elixvp-featured-fragrance',ElixvpFeaturedFragrance);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elixvp-glass-header"] && !Shopify.designMode) return;
  try {
    
class ElixvpHeader extends HTMLElement {
  connectedCallback() {
    this.abortController?.abort();
    this.abortController = new AbortController();
    const signal = this.abortController.signal;
    this.drawer = this.querySelector('.elixvp-header__drawer');
    this.openButton = this.querySelector('.elixvp-header__menu-button');
    this.closeButton = this.querySelector('.elixvp-header__close');
    this.previouslyFocused = null;
    this.closeTimer = null;
    this.isClosing = false;
    if (!this.drawer || !this.openButton || !this.closeButton) return;
    this.openButton.addEventListener('click', () => this.openMenu(), { signal });
    this.closeButton.addEventListener('click', event => {
      event.preventDefault();
      event.stopPropagation();
      this.closeMenu(true);
    }, { signal });
    this.drawer.addEventListener('cancel', event => { event.preventDefault(); this.closeMenu(); }, { signal });
    this.drawer.addEventListener('click', event => {
      if (event.target !== this.drawer) return;
      const rect = this.drawer.getBoundingClientRect();
      const outside = event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom;
      if (outside) this.closeMenu();
    }, { signal });
    this.drawer.querySelectorAll('a').forEach(link => link.addEventListener('click', () => this.closeMenu(true, false), { signal }));
    window.addEventListener('resize', () => { if (window.innerWidth > 989 && this.drawer.open) this.closeMenu(true); }, { signal, passive: true });
  }

  disconnectedCallback() {
    this.abortController?.abort();
    window.clearTimeout(this.closeTimer);
    if (this.drawer?.open) this.drawer.close();
    document.documentElement.classList.remove('elixvp-menu-open');
  }

  openMenu() {
    if (this.drawer.open || window.innerWidth > 989) return;
    this.previouslyFocused = document.activeElement;
    this.drawer.showModal();
    this.openButton.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('elixvp-menu-open');
    requestAnimationFrame(() => {
      this.drawer.classList.add('is-open');
      this.closeButton.focus({ preventScroll: true });
    });
  }

  closeMenu(immediate = false, restoreFocus = true) {
    if (!this.drawer.open || this.isClosing) return;
    this.isClosing = true;
    this.openButton.setAttribute('aria-expanded', 'false');
    this.drawer.classList.remove('is-open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (immediate || reducedMotion) {
      this.finishClose(restoreFocus);
      return;
    }
    const onTransitionEnd = event => {
      if (event.target !== this.drawer || event.propertyName !== 'transform') return;
      this.drawer.removeEventListener('transitionend', onTransitionEnd);
      window.clearTimeout(this.closeTimer);
      this.finishClose(restoreFocus);
    };
    this.drawer.addEventListener('transitionend', onTransitionEnd);
    this.closeTimer = window.setTimeout(() => {
      this.drawer.removeEventListener('transitionend', onTransitionEnd);
      this.finishClose(restoreFocus);
    }, 440);
  }

  finishClose(restoreFocus = true) {
    if (this.drawer.open) this.drawer.close();
    this.drawer.classList.remove('is-open');
    this.openButton.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('elixvp-menu-open');
    this.isClosing = false;
    if (restoreFocus && this.previouslyFocused instanceof HTMLElement) this.previouslyFocused.focus({ preventScroll: true });
  }
}

if (!customElements.get('elixvp-header')) customElements.define('elixvp-header', ElixvpHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elixvp-luxury-hero-slider"] && !Shopify.designMode) return;
  try {
    
class ElixvpSlider extends HTMLElement{connectedCallback(){this.t=this.querySelector('.ehs-t');this.s=[...this.querySelectorAll('[data-slide]')];this.p=[...this.querySelectorAll('[data-go]')];this.th=[...this.querySelectorAll('[data-thumb]')];this.i=0;this.x=null;this.timer=null;this.t.style.transitionDuration=`${Number(this.dataset.speed)||700}ms`;this.p.forEach(b=>b.onclick=()=>this.go(+b.dataset.go));this.th.forEach(b=>b.onclick=()=>this.go(+b.dataset.thumb));this.onkeydown=e=>{if(e.key==='ArrowLeft')this.go(this.i-1);if(e.key==='ArrowRight')this.go(this.i+1)};this.onpointerdown=e=>{this.x=e.clientX;this.stop()};this.onpointerup=e=>{if(this.x===null)return;let d=e.clientX-this.x;this.x=null;if(Math.abs(d)>45)this.go(this.i+(d<0?1:-1));this.start()};this.onmouseenter=()=>this.stop();this.onmouseleave=()=>this.start();document.addEventListener('shopify:block:select',e=>{let s=e.target.closest?.('[data-slide]');if(s&&this.contains(s))this.go(+s.dataset.slide,false)});this.render();this.start()}go(n,r=true){if(this.s.length<2)return;this.i=(n+this.s.length)%this.s.length;this.render();if(r){this.stop();this.start()}}render(){this.t.style.transform=`translate3d(${-this.i*100}%,0,0)`;this.p.forEach(b=>{let a=+b.dataset.go===this.i;b.classList.toggle('active',a);b.setAttribute('aria-selected',a)});let first=true;this.th.forEach((b,j)=>{let d=(j-this.i+this.th.length)%this.th.length,v=d>0&&d<=2;b.classList.toggle('show',v);b.classList.toggle('primary',v&&first);if(v&&first)first=false})}start(){if(this.dataset.auto!=='true'||this.s.length<2||matchMedia('(prefers-reduced-motion:reduce)').matches)return;this.stop();this.timer=setInterval(()=>this.go(this.i+1,false),+this.dataset.delay||6000)}stop(){clearInterval(this.timer);this.timer=null}disconnectedCallback(){this.stop()}}if(!customElements.get('elixvp-slider'))customElements.define('elixvp-slider',ElixvpSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elixvp-new-collection-carousel"] && !Shopify.designMode) return;
  try {
    
  class ElixvpCollectionCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-enc-track]');
      this.prev = this.querySelector('[data-enc-prev]');
      this.next = this.querySelector('[data-enc-next]');
      if (!this.track || !this.prev || !this.next) return;

      this.prev.addEventListener('click', () => this.move(-1));
      this.next.addEventListener('click', () => this.move(1));
      this.track.addEventListener('scroll', () => this.queueState(), { passive: true });
      this.track.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.move(-1);
        }
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.move(1);
        }
      });

      this.resizeObserver = new ResizeObserver(() => this.updateState());
      this.resizeObserver.observe(this.track);
      this.updateState();
    }

    move(direction) {
      const card = this.track.querySelector('.enc__product-card');
      if (!card) return;
      const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
      this.track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
    }

    queueState() {
      cancelAnimationFrame(this.stateFrame);
      this.stateFrame = requestAnimationFrame(() => this.updateState());
    }

    updateState() {
      const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const x = Math.max(0, this.track.scrollLeft);
      const hasOverflow = max > 3;
      this.prev.disabled = !hasOverflow || x <= 3;
      this.next.disabled = !hasOverflow || x >= max - 3;
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.stateFrame);
    }
  }

  if (!customElements.get('elixvp-collection-carousel')) {
    customElements.define('elixvp-collection-carousel', ElixvpCollectionCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nklv-reference-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const boot = (root = document) => {
      root.querySelectorAll('.rpd[data-section-id]').forEach((section) => {
        if (section.dataset.rpdReady === 'true') return;
        section.dataset.rpdReady = 'true';

        const slides = Array.from(section.querySelectorAll('[data-rpd-slide]'));
        const thumbs = Array.from(section.querySelectorAll('[data-rpd-thumb]'));
        let activeIndex = 0;

        const showSlide = (nextIndex) => {
          if (!slides.length) return;
          activeIndex = (nextIndex + slides.length) % slides.length;
          slides.forEach((slide, index) => slide.classList.toggle('is-hidden', index !== activeIndex));
          thumbs.forEach((thumb, index) => thumb.classList.toggle('is-active', index === activeIndex));
          if (thumbs[activeIndex]) thumbs[activeIndex].scrollIntoView({block: 'nearest', inline: 'nearest'});
        };

        thumbs.forEach((thumb) => {
          thumb.addEventListener('click', () => showSlide(Number(thumb.dataset.rpdThumb || 0)));
        });

        section.querySelector('[data-rpd-prev]')?.addEventListener('click', () => showSlide(activeIndex - 1));
        section.querySelector('[data-rpd-next]')?.addEventListener('click', () => showSlide(activeIndex + 1));


        const offerBars = Array.from(section.querySelectorAll('[data-rpd-volume-offer]'));
        let cartItemCount = Math.max(0, Number(section.dataset.rpdCartItemCount || 0));

        const renderOfferBars = (rawQuantity) => {
          const selectedQuantity = Math.max(1, Number(rawQuantity || 1));
          const quantity = cartItemCount > 0 ? cartItemCount : selectedQuantity;

          offerBars.forEach((bar) => {
            const firstQty = Number(bar.dataset.firstQty || 2);
            const secondQty = Number(bar.dataset.secondQty || 3);
            const firstLabel = bar.dataset.firstLabel || 'Buy 2 offer';
            const secondLabel = bar.dataset.secondLabel || 'Buy 3 offer';
            const secondSave = bar.dataset.secondSave || '';
            const message = bar.querySelector('[data-rpd-offer-message]');
            const fill = bar.querySelector('[data-rpd-offer-fill]');
            const firstStep = bar.querySelector('[data-rpd-offer-step="first"]');
            const secondStep = bar.querySelector('[data-rpd-offer-step="second"]');
            const firstDot = bar.querySelector('[data-rpd-offer-dot="first"]');
            const secondDot = bar.querySelector('[data-rpd-offer-dot="second"]');

            let progress = 0;
            let copy = '';

            if (quantity < firstQty) {
              const left = firstQty - quantity;
              copy = 'Add ' + left + ' more to unlock ' + firstLabel;
              progress = Math.max(0, Math.min(50, (quantity / firstQty) * 50));
            } else if (quantity < secondQty) {
              const left = secondQty - quantity;
              copy = firstLabel + ' unlocked · Add ' + left + ' more for ' + secondLabel;
              progress = 50 + Math.max(0, Math.min(50, ((quantity - firstQty) / Math.max(1, secondQty - firstQty)) * 50));
            } else {
              copy = secondLabel + ' unlocked' + (secondSave ? ' · Save ' + secondSave : '');
              progress = 100;
            }

            if (message) message.textContent = copy;
            if (fill) fill.style.width = progress + '%';

            const firstUnlocked = quantity >= firstQty;
            const secondUnlocked = quantity >= secondQty;

            firstStep?.classList.toggle('is-unlocked', firstUnlocked);
            firstStep?.classList.toggle('is-next', !firstUnlocked);
            secondStep?.classList.toggle('is-unlocked', secondUnlocked);
            secondStep?.classList.toggle('is-next', firstUnlocked && !secondUnlocked);
            firstDot?.classList.toggle('is-unlocked', firstUnlocked);
            secondDot?.classList.toggle('is-unlocked', secondUnlocked);
          });
        };

        const qtyGroups = section.querySelectorAll('[data-rpd-qty]');
        qtyGroups.forEach((group) => {
          const input = group.querySelector('input');
          const minus = group.querySelector('[data-rpd-minus]');
          const plus = group.querySelector('[data-rpd-plus]');
          if (!input) return;

          const step = Number(input.step || 1);
          const min = Number(input.min || 1);

          minus?.addEventListener('click', () => {
            input.value = String(Math.max(min, Number(input.value || min) - step));
            renderOfferBars(Number(input.value || min));
          });

          plus?.addEventListener('click', () => {
            input.value = String(Number(input.value || min) + step);
            renderOfferBars(Number(input.value || min));
          });

          input.addEventListener('input', () => renderOfferBars(Number(input.value || min)));
          input.addEventListener('change', () => renderOfferBars(Number(input.value || min)));
        });

        const firstQuantityInput = section.querySelector('[data-rpd-qty] input');
        renderOfferBars(Number(firstQuantityInput?.value || 1));

        section.addEventListener('rpd:cart-sync', (event) => {
          const nextCount = Number(event.detail?.itemCount || 0);
          cartItemCount = Number.isFinite(nextCount) ? Math.max(0, nextCount) : 0;
          section.dataset.rpdCartItemCount = String(cartItemCount);
          renderOfferBars(Number(firstQuantityInput?.value || 1));
        });

        const stickyInput = section.querySelector('[data-rpd-sticky-input]');
        const stickyFormQuantity = section.querySelector('[data-rpd-sticky-form-quantity]');
        const syncStickyQuantity = () => {
          if (stickyInput && stickyFormQuantity) stickyFormQuantity.value = stickyInput.value;
        };

        if (stickyInput) {
          const step = Number(stickyInput.step || 1);
          const min = Number(stickyInput.min || 1);

          section.querySelector('[data-rpd-sticky-minus]')?.addEventListener('click', () => {
            stickyInput.value = String(Math.max(min, Number(stickyInput.value || min) - step));
            syncStickyQuantity();
          });

          section.querySelector('[data-rpd-sticky-plus]')?.addEventListener('click', () => {
            stickyInput.value = String(Number(stickyInput.value || min) + step);
            syncStickyQuantity();
          });

          stickyInput.addEventListener('change', syncStickyQuantity);
        }

        const countdownBars = Array.from(section.querySelectorAll('[data-rpd-countdown]'));
        countdownBars.forEach((bar) => {
          const cycleDays = Math.max(1, Number(bar.dataset.cycleDays || 3));
          const cycleMs = cycleDays * 24 * 60 * 60 * 1000;
          const storageKey = bar.dataset.storageKey || ('nklv-evergreen-countdown-v1-' + cycleDays);

          const daysNode = bar.querySelector('[data-rpd-days]');
          const hoursNode = bar.querySelector('[data-rpd-hours]');
          const minutesNode = bar.querySelector('[data-rpd-minutes]');
          const secondsNode = bar.querySelector('[data-rpd-seconds]');

          const saveEnd = (value) => {
            try {
              window.localStorage.setItem(storageKey, String(value));
            } catch (error) {
              // Storage can be unavailable in strict privacy modes; the timer still works for this page view.
            }
          };

          let end = 0;
          try {
            end = Number(window.localStorage.getItem(storageKey) || 0);
          } catch (error) {
            end = 0;
          }

          const now = Date.now();
          if (!Number.isFinite(end) || end <= 0) {
            end = now + cycleMs;
            saveEnd(end);
          } else if (end <= now) {
            const cyclesPassed = Math.floor((now - end) / cycleMs) + 1;
            end += cyclesPassed * cycleMs;
            saveEnd(end);
          }

          const renderCountdown = () => {
            const currentTime = Date.now();

            if (end <= currentTime) {
              const cyclesPassed = Math.floor((currentTime - end) / cycleMs) + 1;
              end += cyclesPassed * cycleMs;
              saveEnd(end);
            }

            const diff = Math.max(0, end - currentTime);
            const total = Math.ceil(diff / 1000);
            const days = Math.floor(total / 86400);
            const hours = Math.floor((total % 86400) / 3600);
            const minutes = Math.floor((total % 3600) / 60);
            const seconds = total % 60;

            if (daysNode) daysNode.textContent = String(days).padStart(2, '0');
            if (hoursNode) hoursNode.textContent = String(hours).padStart(2, '0');
            if (minutesNode) minutesNode.textContent = String(minutes).padStart(2, '0');
            if (secondsNode) secondsNode.textContent = String(seconds).padStart(2, '0');
          };

          renderCountdown();
          window.setInterval(renderCountdown, 1000);
        });

                const variantSelects = Array.from(section.querySelectorAll('[data-rpd-variant-select]'));
        const stickyVariant = section.querySelector('[data-rpd-sticky-variant]');
        const stickyPrice = section.querySelector('[data-rpd-sticky-price]');
        const priceNodes = section.querySelectorAll('[data-rpd-price]');
        const compareNodes = section.querySelectorAll('[data-rpd-compare]');
        const addButtons = section.querySelectorAll('[data-rpd-add], [data-rpd-sticky-add], [data-rpd-buy-now]');

        const applyVariant = (select) => {
          const option = select?.selectedOptions?.[0];
          if (!option) return;

          variantSelects.forEach((other) => {
            if (other !== select) other.value = option.value;
          });

          if (stickyVariant) stickyVariant.value = option.value;
          if (stickyPrice) stickyPrice.textContent = option.dataset.price || '';

          priceNodes.forEach((node) => {
            node.textContent = option.dataset.price || '';
          });

          compareNodes.forEach((node) => {
            node.textContent = option.dataset.compare || '';
            node.hidden = !option.dataset.compare;
          });

          const available = option.dataset.available === 'true';
          addButtons.forEach((button) => {
            button.disabled = !available;
          });

          const mediaId = option.dataset.mediaId;
          if (mediaId) {
            const mediaIndex = slides.findIndex((slide) => slide.dataset.mediaId === mediaId);
            if (mediaIndex >= 0) showSlide(mediaIndex);
          }
        };

        variantSelects.forEach((select) => select.addEventListener('change', () => applyVariant(select)));

        section.querySelectorAll('[data-rpd-buy-now]').forEach((button) => {
          button.addEventListener('click', async () => {
            const form = button.closest('form');
            if (!form || button.disabled) return;

            button.disabled = true;
            try {
              const root = window.Shopify?.routes?.root || '/';
              const response = await fetch(root + 'cart/add.js', {
                method: 'POST',
                headers: {'Accept': 'application/json'},
                body: new FormData(form)
              });

              if (!response.ok) throw new Error('Unable to add item');
              window.location.assign(root + 'checkout');
            } catch (error) {
              button.disabled = false;
              form.submit();
            }
          });
        });
      });
    };

    boot();
    document.addEventListener('shopify:section:load', (event) => boot(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
